import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import useModal from 'hooks/useModal';
import { VesselData, VesselModel } from 'models/VesselModel';
import VesselDialog from 'modules/vessels/dialogs/VesselDialog';
import vesselList from 'recoil/atoms/vesselList';
import Api from 'utils/api';
import { replaceItemAtIndex } from 'utils/common';


const useVesselModals = () => {
    const {t} = useTranslation();
    const setVessels = useSetRecoilState(vesselList);
    const {showModal, hideModal} = useModal();

    const createVessel = (vessel: VesselData) => Api.vessels.create(vessel)
        .then(res => {
            setVessels(old => [res.data.data, ...old]);
            return res.data.data.id;
        });

    const updateVessel = (vessel: VesselModel) => Api.vessels.update(vessel)
        .then(res => setVessels(old => replaceItemAtIndex(old, old.findIndex(i => i.id === vessel.id), res.data.data)));

    const openAddVesselModal = () => showModal(VesselDialog,
        {action: t('add')},
        {
            title: t('add_title', {value: t('vessel')})
        })
        .then(createVessel)
        .then(id => {
            hideModal();
            return id;
        });

    const openEditVesselModal = (vessel: VesselModel) => showModal(VesselDialog,
        {
            action: t('save'),
            vessel
        },
        {
            title: t('edit_title', {value: t('vessel')})
        })
        .then(updateVessel)
        .then(hideModal);

    return {
        openAddVesselModal,
        openEditVesselModal,
    };
};

export default useVesselModals;
